import { ImageDTOApi } from "../Image/ImageDTO";
import NewsImageDTO from "../Image/NewsImageDTO";
import {
  EmptyNewsItemPropImpl,
  NewsItemResponseApi,
} from "../ServerResponseType/News/NewsItem";
import { CheckArgs } from "../../utils/checks/CheckArgsWithoutThrow";

export interface LittleNewsApi {
  newsId: string;
  newsTitle: string;
  newsImage: ImageDTOApi;
  newsPreviewText: string;
  newsDate: string;
}

export class LittleNewsImpl implements LittleNewsApi {
  private newsItemResponse: NewsItemResponseApi;

  constructor(newsItemResponse: NewsItemResponseApi) {
    this.newsItemResponse = newsItemResponse;
  }

  get newsId(): string {
    return this.newsItemResponse.newsId;
  }

  get newsTitle(): string {
    return this.newsItemResponse.newsTitle;
  }

  get newsDate(): string {
    return this.newsItemResponse.newsDate;
  }

  get newsPreviewText(): string {
    return this.newsItemResponse.newsPreviewText;
  }

  get newsImage(): NewsImageDTO {
    let newsImages = this.newsItemResponse.newsImages;
    let newsImage;
    if (CheckArgs.CheckArrayAndNotEmpty(newsImages)) newsImage = newsImages[0];
    return new NewsImageDTO(newsImage);
  }
}

export class EmptyLittleNewsImpl extends LittleNewsImpl {
  constructor() {
    super(new EmptyNewsItemPropImpl());
  }
}
